export const voicesTypeControl = {
	play: 0,
	pause: 1,
	stop: 2
}